export const CHECKOUT_URL =
  'https://aire-acondicionado-automotriz-desde-cero.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/7pGHcyZAxDeu6DKXBxRuyi/Mega_Pack_de_Aire_Acondicionado_Automotriz.png'

export const PRODUCT_NAME = 'MEGA PACK AIRE ACONDICIONADO AUTOMOTRIZ DESDE CERO'

export const PRICE = '$19.990'

export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos sobre compresores, refrigerantes, presiones, sensores y reparaciones, pero cada uno explica algo diferente y no sabes cómo relacionar todo.',
  },
  {
    title: 'NO SABES QUÉ APRENDER PRIMERO',
    desc: 'Compresores, condensadores, evaporadores, manifold, refrigerantes, sensores, electricidad... hay tantos componentes y procedimientos que empezar parece complicado.',
  },
  {
    title: 'TE FALTA UNA RUTA',
    desc: 'Quieres aprender una habilidad técnica que puedas convertir en un nuevo servicio, pero necesitas un camino que vaya desde los fundamentos hasta el diagnóstico y la reparación.',
  },
  {
    title: 'SIGUES POSTERGANDO',
    desc: 'Quieres comenzar, pero pasan las semanas y continúas buscando información en lugar de avanzar con un método organizado.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'FUNDAMENTOS DEL AIRE ACONDICIONADO AUTOMOTRIZ',
    desc: 'Comprende cómo funciona el sistema de climatización, el ciclo de refrigeración, la transferencia de calor, las presiones, las temperaturas y los principios que permiten enfriar el habitáculo.',
  },
  {
    title: 'COMPONENTES, COMPRESORES Y SISTEMAS DE REFRIGERACIÓN',
    desc: 'Conoce los principales componentes del sistema, compresores, condensadores, evaporadores, válvulas de expansión, filtros, tuberías y sus funciones dentro del circuito.',
  },
  {
    title: 'REFRIGERANTES, PRESIONES Y DIAGNÓSTICO CON MANIFOLD',
    desc: 'Aprende los fundamentos de los refrigerantes, la interpretación de presiones, las mediciones con manifold, las temperaturas y los procedimientos de diagnóstico.',
  },
  {
    title: 'ELECTRICIDAD, ELECTRÓNICA Y SENSORES DEL AIRE ACONDICIONADO',
    desc: 'Comprende circuitos eléctricos, fusibles, relés, sensores, electroventiladores, módulos electrónicos, señales de control y diagnóstico eléctrico.',
  },
  {
    title: 'DIAGNÓSTICO DE FALLAS Y REPARACIÓN PASO A PASO',
    desc: 'Aprende un método ordenado para identificar problemas de enfriamiento, fallas del compresor, fugas, averías eléctricas y procedimientos de reparación.',
  },
  {
    title: 'MANTENIMIENTO PROFESIONAL Y SERVICIOS DE AIRE ACONDICIONADO AUTOMOTRIZ',
    desc: 'Aprende a organizar inspecciones, realizar controles preventivos, verificar el funcionamiento, documentar servicios y preparar presupuestos para trabajos de climatización.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '50 MAPAS VISUALES DE DIAGNÓSTICO AUTOMOTRIZ',
    desc: '50 rutas de diagnóstico para comprender síntomas, identificar posibles causas, organizar comprobaciones y analizar fallas de refrigeración, compresores, ventilación y electricidad.',
    value: '$7.990',
  },
  {
    title: 'TABLAS DE PRESIONES, TEMPERATURAS Y VALORES DE REFERENCIA',
    desc: 'Tablas y recursos para interpretar presiones, temperaturas, refrigerantes, conversiones, condiciones de funcionamiento y resultados de mediciones.',
    value: '$5.990',
  },
  {
    title: '30 DIAGRAMAS ELÉCTRICOS DE AIRE ACONDICIONADO AUTOMOTRIZ',
    desc: '30 esquemas explicativos para comprender circuitos, fusibles, relés, sensores, compresores, electroventiladores, controles y conexiones eléctricas.',
    value: '$6.990',
  },
  {
    title: '100 FALLAS FRECUENTES DEL AIRE ACONDICIONADO AUTOMOTRIZ',
    desc: '100 situaciones de práctica organizadas mediante síntomas, posibles causas y comprobaciones para comprender problemas mecánicos, eléctricos y de refrigeración.',
    value: '$8.990',
  },
  {
    title: 'CHECKLIST PROFESIONAL DE DIAGNÓSTICO Y MANTENIMIENTO',
    desc: 'Listas de verificación, fichas técnicas, formularios de recepción, registros de mediciones, presupuestos y controles para organizar cada servicio.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre contenidos y sigue una ruta desde los fundamentos hasta el diagnóstico, mantenimiento y reparación del aire acondicionado automotriz.',
  },
  {
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprende compresores, refrigerantes, presiones, manifold, condensadores, evaporadores, sensores, circuitos eléctricos y diagnóstico con explicaciones organizadas.',
  },
  {
    title: 'COMPRENDE LO QUE ESTÁS VIENDO',
    desc: 'Empieza a revisar un sistema de aire acondicionado y reconocer qué componentes intervienen, cómo se relacionan y qué función cumple cada uno.',
  },
  {
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construye conocimientos que pueden convertirse en el primer paso para incorporar un nuevo servicio técnico y ampliar tus posibilidades profesionales.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Había visto muchos videos sobre compresores, refrigerantes y presiones, pero seguía sin entender cómo se relacionaban los componentes. Con los tomos ordenados finalmente entendí la lógica del sistema y por dónde comenzar a diagnosticar.',
    author: 'Matías Correa',
    role: 'Ayudante de taller mecánico, 24 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Lo que más me ayudó fue entender que no todo se soluciona cargando refrigerante. Hay que revisar presiones, temperaturas, ventilación y componentes. Ahora puedo analizar un sistema con mucho más orden.',
    author: 'Gonzalo Pereyra',
    role: 'Técnico en refrigeración domiciliaria, 35 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Trabajo con mecánica y quería sumar aire acondicionado, pero no sabía qué estudiar primero. El sistema me ayudó a conectar la parte mecánica con refrigerantes, electricidad y diagnóstico.',
    author: 'Sergio Villalba',
    role: 'Mecánico automotor, 42 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Entré buscando aprender a usar el manifold y terminé entendiendo también diagnóstico. Las 100 fallas me ayudaron a pensar primero en el síntoma, después en las causas y recién entonces buscar una solución.',
    author: 'Valentina Suárez',
    role: 'Estudiante de mecánica automotriz, 21 años',
    location: 'La Plata, Argentina',
  },
  {
    quote:
      'Quería agregar un servicio nuevo a lo que ya hacía. Las fichas, los controles de mantenimiento y los presupuestos me dieron una estructura mucho más clara para organizarme y practicar antes de ofrecerlo.',
    author: 'Ramiro Ledesma',
    role: 'Electricista del automotor, 38 años',
    location: 'San Miguel de Tucumán, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El contenido comienza con los fundamentos y avanza progresivamente hacia componentes, refrigerantes, electricidad, diagnóstico y mantenimiento.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Aprenderás cómo funciona el aire acondicionado automotriz, sus componentes, refrigerantes, presiones, mediciones, sensores, circuitos eléctricos, diagnóstico de fallas y mantenimiento.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye casos prácticos, mapas de diagnóstico, diagramas, tablas de referencia, fallas frecuentes y checklists de trabajo.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos sin costo adicional con la compra del Mega Pack.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizas un único pago de $19.990, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Después de confirmar el pago, recibes acceso al material digital mediante el sistema de entrega.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es material educativo. Para realizar determinados trabajos se necesita capacitación práctica, equipamiento apropiado y cumplir los requisitos de seguridad y normativa correspondientes.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes estudiar los tomos, repasar los contenidos y consultar los bonos siguiendo tu propio ritmo.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes escribir a soportescmdigital@gmail.com para consultas relacionadas con el acceso al producto.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Martín Gómez', city: 'Córdoba', minutes: 2 },
  { name: 'Lucas Romero', city: 'Rosario', minutes: 4 },
  { name: 'Diego Fernández', city: 'Buenos Aires', minutes: 7 },
  { name: 'Julián Díaz', city: 'Mendoza', minutes: 11 },
  { name: 'Facundo Medina', city: 'La Plata', minutes: 15 },
  { name: 'Brian Torres', city: 'Mar del Plata', minutes: 19 },
  { name: 'Leandro Acosta', city: 'Salta', minutes: 24 },
  { name: 'Ezequiel Molina', city: 'San Miguel de Tucumán', minutes: 29 },
  { name: 'Nahuel Ríos', city: 'Neuquén', minutes: 33 },
  { name: 'Carolina Herrera', city: 'Santa Fe', minutes: 40 },
]
